import React, { FC } from "react";
import { Modal, Row, Col, Typography, Tag, Space, Card } from "antd";
import { CloseOutlined, EyeOutlined, FileTextOutlined, MessageOutlined } from "@ant-design/icons";

const { Text } = Typography;

type ViewQueryDocumentDeficiencyModalProps = {
  visible: boolean;
  onClose: () => void;
  viewedQuery?: any;
  handleOpenUploadedDocument: any;
  handleViewDeficiencyFailedDocument: any;
};

const ViewQueryDocumentDeficiencyModal: FC<
  ViewQueryDocumentDeficiencyModalProps
> = ({
  visible,
  onClose,
  viewedQuery,
  handleOpenUploadedDocument,
  handleViewDeficiencyFailedDocument,
}) => {
  return (
    <Modal
      title={
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "8px 0"
        }}>
          <Space>
            <FileTextOutlined style={{ color: "#00549e", fontSize: 18 }} />
            <span style={{ fontSize: 16, fontWeight: 600, color: "#00549e" }}>
              DEFICIENCY QUERY DETAILS
            </span>
          </Space>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      width={1100}
      className="create-query-modal"
      closeIcon={<CloseOutlined style={{ background: "white" }} />}
      style={{
        borderRadius: 12,
        overflow: "auto",
        top: 2,
          left: 4,
          padding: 0,
      }}
      bodyStyle={{
        padding: "24px",
        background: "#fafafa"
      }}
    >
      {/* Query Request Section */}
      <Card
        style={{
          marginBottom: 24,
          borderRadius: 8,
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          border: "1px solid #e5e7eb"
        }}
        bodyStyle={{ padding: "20px" }}
      >
        <Space align="center" style={{ marginBottom: 16 }}>
          <MessageOutlined style={{ color: "#ef4444", fontSize: 16 }} />
          <Text strong style={{ fontSize: 14, color: "#374151" }}>
            QUERY REQUEST
          </Text>
        </Space>
        <div style={{
          background: "#f8fafc",
          borderRadius: 8,
          padding: 16,
          border: "1px solid #e2e8f0"
        }}>
          <Row gutter={16} align="middle">
            <Col span={12}>
              <Tag color="red" style={{ fontSize: 14, padding: "4px 12px" }}>
                <EyeOutlined
                  style={{ cursor: "pointer", marginRight: 8 }}
                  onClick={() =>
                    handleViewDeficiencyFailedDocument(viewedQuery)
                  }
                />
                {viewedQuery?.oldDocument?.documentLabelType}
              </Tag>
            </Col>
            <Col span={12}>
              <div
                style={{
                  background: "#fef2f2",
                  border: "1px solid #fecaca",
                  borderRadius: 6,
                  padding: 12,
                  color: "#dc2626",
                  fontSize: 14,
                  lineHeight: 1.5
                }}
              >
                {viewedQuery?.receivedQuery}
              </div>
            </Col>
          </Row>
        </div>
      </Card>

      {/* Query Response Section */}
      <Card
        style={{
          borderRadius: 8,
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          border: "1px solid #e5e7eb"
        }}
        bodyStyle={{ padding: "20px" }}
      >
        <Space align="center" style={{ marginBottom: 16 }}>
          <MessageOutlined style={{ color: "#00549e", fontSize: 16 }} />
          <Text strong style={{ fontSize: 14, color: "#374151" }}>
            QUERY RESPONSE
          </Text>
        </Space>
        <div style={{
          background: "#f0f9ff",
          borderRadius: 8,
          padding: 16,
          border: "1px solid #bae6fd"
        }}>
          <Row gutter={16} align="middle">
            <Col span={12}>
              <Tag
                color={
                  viewedQuery?.newDocument?.deficiencyCheckStatus === true
                    ? "success"
                    : viewedQuery?.newDocument?.deficiencyCheckStatus === false
                    ? "error"
                    : "default"
                }
                style={{ fontSize: 14, padding: "4px 12px" }}
              >
                <EyeOutlined
                  style={{ cursor: "pointer", marginRight: 8 }}
                  onClick={() => {
                    handleOpenUploadedDocument(
                      viewedQuery?.oldDocument?.documentLabelType
                    );
                  }}
                />
                {viewedQuery?.oldDocument?.documentLabelType}
              </Tag>
            </Col>
            <Col span={12}>
              <div
                style={{
                  background: "#f0fdf4",
                  border: "1px solid #bbf7d0",
                  borderRadius: 6,
                  padding: 12,
                  color: "#166534",
                  fontSize: 14,
                  lineHeight: 1.5
                }}
              >
                {viewedQuery?.returnedResponse}
              </div>
            </Col>
          </Row>
        </div>
      </Card>
    </Modal>
  );
};

export default ViewQueryDocumentDeficiencyModal;
